import './bootstrap.js';

import './jquery-ui-imports.js';
import 'jquery-ui/dist/themes/base/jquery-ui.min.css';

import 'slick-carousel'
/*import '../../../public/web_assets/js/jssocials.min.js'*/

/*import '../../../public/web_assets/js/smoke/smoke.js'*/
/*import '../../../public/web_assets/js/rellax/rellax.min.js'*/

import Dropzone from "dropzone";
window.Dropzone = Dropzone;

import './swalScript.js'

//import './smoke/smoke.js'
//import './rellax/rellax.min.js';
import './jssocials.min.js'

import './fancyboxScript.js'
import './dropzoneScript.js'
import './smokeBg.js'
import './rellaxScript.js'
import './heroSlider.js'
import './slider.js'
import './newsletter.js'
import './script.js'
import './contact-form.js'
